import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import initFollowCursor from '../follow-cursor';

const initImageGalleries = (section) => {
    const mouseEls = section.querySelectorAll('.js-follow-cursor');
    const prevEls = section.querySelectorAll('.js-home-gallery-prev');
    const nextEls = section.querySelectorAll('.js-home-gallery-next');

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        on: {
            setTranslate(swiper) {
                swiper.slides.forEach((slideEl, index) => {
                    const isVisible = swiper.visibleSlidesIndexes.includes(index);
                    slideEl.classList.toggle('swiper-slide-fully-visible', isVisible);
                });
            },
        },
    });

    // Navigation init
    prevEls.forEach((element) => {
        element.addEventListener('click', () => {
            swiper.slidePrev();
        });
    });

    nextEls.forEach((element) => {
        element.addEventListener('click', () => {
            swiper.slideNext();
        });
    });

    if (mouseEls && mouseEls.length > 0) {
        mouseEls.forEach((mouseEl) => {
            initFollowCursor(mouseEl, mouseEl.parentNode);
        });
    }
};

export default initImageGalleries;
